<template>
  <div class="tamaños">
    <div class="scroles">
      <NavbarHorizontal   />
      <NavbarVertical   />

    </div>
  </div>
</template>

<script>
import NavbarVertical from "@/components/ModSeleccion/Navbar/navbarVertical.vue";
import NavbarHorizontal from "@/components/ModSeleccion/Navbar/navbarHorizontal.vue";
export default {
  name: "SolimanoextranetPrueba",

  components: {
    NavbarVertical,
    NavbarHorizontal,
  },

  data() {
    return {};
  },

  mounted() {
   
    
  },

  computed:{

  },

  methods: {},
};
</script>

<style scoped>

.tamaños {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.scroles {
  flex: 1;
  overflow-y: auto;
}
.footer {
  margin-top: auto;
}
</style>
